import { Flex, Image } from "@mantine/core";

interface IHelpCenterImageProps {
  src: string;
  className?: string;
}

const HelpCenterImage: React.FC<IHelpCenterImageProps> = ({
  src,
  className,
}) => {
  return (
    <Flex justify="center">
      <Image className={`min-w-full rounded-2xl ${className}`} src={src} />
    </Flex>
  );
};

export default HelpCenterImage;
